import api from './api';

export interface UploadImagemResponse {
  caminhoImagem: string;
  nomeArquivo: string;
  nomeOriginal: string;
  tamanho: number;
  tipoMime: string;
}

export class ImagemService {
  private baseUrl = '/imagem';

  /**
   * Faz upload de uma imagem
   */
  async uploadImagem(arquivo: File): Promise<UploadImagemResponse> {
    const formData = new FormData();
    formData.append('imagem', arquivo);

    const response = await api.post<UploadImagemResponse>(
      `${this.baseUrl}/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  }

  /**
   * Busca uma imagem pelo nome do arquivo
   */
  async buscarImagem(nomeArquivo: string): Promise<Blob> {
    const response = await api.get(`${this.baseUrl}/${nomeArquivo}`, {
      responseType: 'blob',
    });

    return response.data;
  }

  /**
   * Deleta uma imagem
   */
  async deletarImagem(nomeArquivo: string): Promise<void> {
    await api.delete(`${this.baseUrl}/${nomeArquivo}`);
  }

  /**
   * Retorna a URL completa da imagem
   */
  getImagemUrl(caminhoImagem: string): string {
    if (!caminhoImagem) return '';
    
    const baseUrl = import.meta.env.VITE_API_URL || 'http://p0oswcss8sggs44c8g0gsw00.72.60.250.39.sslip.io';
    
    // Se já começar com http, retorna como está
    if (caminhoImagem.startsWith('http')) {
      return caminhoImagem;
    }
    
    // Se começar com /, remove a barra inicial para evitar duplicação
    const caminho = caminhoImagem.startsWith('/') ? caminhoImagem.slice(1) : caminhoImagem;
    
    return `${baseUrl}/${caminho}`;
  }
}

export const imagemService = new ImagemService();
